
import store from './../../store';
import { convertMinutesToMilliseconds } from '../../AAFPersistenceManager/helpers/Utils';
import UserFavoritedLive from '../../requests/tasks/epg/UserFavoritedLive';
import RequestManager from '../../requests/RequestManager';
import Utils from '../../utils/Utils';
import AAF from "../AAF";
import { FAVORITED_LIVE_TTL } from "../../AAF/Resilence/TTLConstants";

let favsArray = [];
let idFav = null;
const defaultKey = '{"minutes":6}';
const TTLItem = FAVORITED_LIVE_TTL;

const start = () => {
    stop();
    let minutes = getTimeToGetFavs().minutes;
    if(minutes === undefined){
        const temp =  JSON.parse(defaultKey);
        if(temp && temp.minutes){
            minutes = temp.minutes;
        }
    }
    if (!idFav) {
        getFavs();
        AAF.TTLUtil.setStorageItemTTL(TTLItem);
        const milliseconds = convertMinutesToMilliseconds(minutes);
        idFav = setInterval(() => {
            getFavs();
            AAF.TTLUtil.setStorageItemTTL(TTLItem);
        }, milliseconds);
    }
}


const stop = ()  => {
    clearInterval(idFav);
    idFav = null;
    favsArray = [];
}



const getTimeToGetFavs = function() {
    try {
      let metadataKey = Utils.getApaMetadataKey('time_to_get_favs', defaultKey);
      return metadataKey;
    } catch (e) {
      return { minutes: 5 };
    }
};

const setFavs = (favs = []) => {
    if(favs && Array.isArray(favs) && favs.length > 0 ){
        const favsFilter = favs.filter( ch =>  (ch && ch.id));
        favsArray = favsFilter.map((el) =>{
            return el && el.id;
        });
    }
}

const getAllFavs = () => {
    AAF.TTLUtil.verifyTTLItem(TTLItem, () => { 
        getFavs();
        AAF.TTLUtil.setStorageItemTTL(TTLItem);
        
        return;
    }, 'LoadFav[getAllFavs]');

    return favsArray;
}

const addFav = (groupID) =>{
    // evitar duplicados
    if(Array.isArray(favsArray) && !favsArray.hasOwnProperty(groupID)){
        favsArray.push(groupID);
    }
}

const deleteFav = (groupID) =>{
    if(!groupID) return;
    favsArray = favsArray.filter(gid => gid !== groupID);
}

const isFavorite = (groupID) =>{
    return Array.isArray(favsArray) && favsArray.indexOf(groupID) > -1 || false;
}

const isEmpty = () =>{
    return !(Array.isArray(favsArray) && favsArray.length > 0);
}


const getFavs = async () => {
    if (store && typeof store.getState === 'function') {
        const state = store.getState();
        const { user = {} } = state;
        if(user && user.isAnonymous) return;
        const favFavsLive = new UserFavoritedLive();
        const result = await RequestManager.addRequest(favFavsLive);
        if(result && result.response && result.response.groups){
            setFavs(result.response.groups);
        }
    }
}

const LoadFav = {
    start,
    getAllFavs,
    addFav,
    deleteFav,
    isFavorite,
    isEmpty
};

export default LoadFav;


// WEBPACK FOOTER //
// ./src/AAF/LoaderExp/LoadFav.js